import React from 'react';

export function OccPill({ state, children }) {
  return <span className={`ddo-pill ddo-pill--${state}`}>{children}</span>;
}

// active: boolean
export function ActivePill({ active, children }) {
  return <span className={`ddo-pill ddo-pill--${active ? 'on' : 'off'}`}>{children}</span>;
}
